import { Share, Favorite, FavoriteBorder } from '@mui/icons-material';
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import welfareService from '../utils/welfareService';
import Loader from '../components/Loader';
import RatingSection from '../components/RatingSection';
import GalleryModal from '../components/GalleryModal';
import { snackbar } from '../utils/showMessage';
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ServiceDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [service, setService] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isFavorite, setIsFavorite] = useState(false);
    const [galleryOpen, setGalleryOpen] = useState(false);
    const [galleryIndex, setGalleryIndex] = useState(0);

    useEffect(() => {
        loadService();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const loadService = async () => {
        try {
            setLoading(true);
            const data = await welfareService.getServiceById(id);
             setService(data);
        } catch (error) {
            console.error('Error loading service:', error);
            snackbar('خطا در بارگذاری اطلاعات خدمت');
            navigate('/');
        } finally {
            setLoading(false);
        }
    };

    const handleShare = () => {
        if (navigator.share) {
            navigator.share({
                title: service.title,
                text: service.description,
                url: window.location.href,
            }).catch(err => console.error('Error sharing:', err));
        } else {
            navigator.clipboard.writeText(window.location.href);
            snackbar('لینک کپی شد');
        }
    };

    const toggleFavorite = () => {
        setIsFavorite(!isFavorite);
        snackbar(isFavorite ? 'از علاقه‌مندی‌ها حذف شد' : 'به علاقه‌مندی‌ها اضافه شد');
    };

    if (loading) {
        return <Loader />;
    }

    if (!service) {
        return null;
    }

    /* price removed from service model */

    return (
        <div className="main-container container">





            {/* Image */}
            {service.image && (
                <div className="row mb-3">
                    <div className="col-12" style={{
                        position: 'relative'
                    }}>
                        <img
                            src={`${BASE_URL}/uploads/documents/${service.image}`}
                            alt={service.title}
                            className="w-100 rounded-15"
                            style={{ maxHeight: '300px', objectFit: 'cover' }}
                        />
                        <div className="  mb-3" style={{
                            position: "absolute",
                            top: 10,
                            left: 20
                        }}>

                            <div style={{
                                display: "flex",
                                flexDirection: "column"
                            }}>
                                <button type="button"
                                    className="btn btn-light btn-32 btn-rounded border-0 mb-2"
                                    onClick={handleShare}>
                                    <Share fontSize='16' />
                                </button>
                                <button type="button"
                                    className="btn btn-light btn-32 btn-rounded border-0"
                                    onClick={toggleFavorite}>
                                    {isFavorite ? <Favorite color="error" fontSize='16' /> : <FavoriteBorder fontSize='12' />}
                                </button>
                            </div>
                        </div>

                        {/* Category */}
                        {service.categoryId && (
                            <div className="row mb-3" style={{
                                position: "absolute",
                                bottom: 0,
                                right: 20
                            }}>
                                <div className="col-12">
                                    <Link
                                        to={`/welfare/${service.categoryId._id}`}
                                        className="badge bg-light text-dark"
                                    >
                                        {service.categoryId.title}
                                    </Link>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )
            }

            {/* price removed from model; pricing UI hidden */}

            {/* Title */}
            <div className="row mb-3">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <h6 >{service.title}</h6>
                        </div>
                    </div>
                </div>
            </div>

            {/* Description */}
            <div className="row mb-3">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <h6 className="mb-3">توضیحات</h6>
                            <p className="text-justify">{service.description}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Metadata */}
            {
                service.metadata && (service.metadata.provider || service.metadata.location || service.metadata.duration || (service.metadata.conditions && service.metadata.conditions.length)) && (
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <h6 className="mb-3">جزئیات</h6>
                                    {service.metadata.provider && (
                                        <p>
                                            <strong>ارائه‌دهنده:</strong> {service.metadata.provider}
                                        </p>
                                    )}
                                    {service.metadata.location && (
                                        <p>
                                            <strong>مکان:</strong> {service.metadata.location}
                                        </p>
                                    )}
                                    {service.metadata.duration && (
                                        <p>
                                            <strong>مدت باقیمانده:</strong> {(() => {
                                                const endDate = new Date(service.metadata.duration);
                                                const now = new Date();
                                                const diffTime = endDate - now;
                                                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                                                if (isNaN(diffDays)) return 'نامعتبر';
                                                if (diffDays < 0) return 'پایان یافته';
                                                if (diffDays > 30) {
                                                    const months = Math.floor(diffDays / 30);
                                                    const days = diffDays % 30;
                                                    return `${months} ماه و ${days} روز باقیمانده`;
                                                }
                                                return `${diffDays} روز باقیمانده`;
                                            })()}
                                        </p>
                                    )}
                                    {service.metadata.conditions && service.metadata.conditions.length > 0 && (
                                        <div>
                                            <strong>شرایط:</strong>
                                            <ul>
                                                {service.metadata.conditions.map((condition, index) => (
                                                    <li key={index}>{condition}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            {/* Gallery */}
            {service.gallery && service.gallery.length > 0 && (
                <div className="row mb-3">
                    <div className="col-12 d-flex flex-nowrap overflow-auto" style={{ gap: '10px' }}>
                        {service.gallery.map((img, idx) => (
                            <img
                                key={idx}
                                src={`${BASE_URL}/uploads/documents/${img}`}
                                alt={`gallery-${idx}`}
                                className="rounded-15"
                                style={{ height: '120px', width: 'auto', objectFit: 'cover', flex: '0 0 auto', cursor: 'pointer' }}
                                onClick={() => { setGalleryIndex(idx); setGalleryOpen(true); }}
                            />
                        ))}
                    </div>
                    <GalleryModal
                        open={galleryOpen}
                        image={service.gallery && service.gallery.length > 0 ? `${BASE_URL}/uploads/documents/${service.gallery[galleryIndex]}` : ''}
                        onClose={() => setGalleryOpen(false)}
                        onPrev={() => setGalleryIndex(i => i > 0 ? i - 1 : i)}
                        onNext={() => setGalleryIndex(i => i < service.gallery.length - 1 ? i + 1 : i)}
                        hasPrev={galleryIndex > 0}
                        hasNext={service.gallery && galleryIndex < service.gallery.length - 1}
                    />
                </div>
            )}
            {/* Action Button */}
            {
                service.link && (
                    <div className="row mb-3">
                        <div className="col-12">
                            <a
                                href={service.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-lg btn-block btn-primary w-100"
                            >
                                مشاهده و استفاده از خدمت
                            </a>
                        </div>
                    </div>
                )
            }

            {/* Rating Section */}
            <RatingSection serviceId={id} />
        </div >
    );
};

export default ServiceDetail;
